import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatTooltipModule} from '@angular/material/tooltip';
import {TranslateModule} from '@ngx-translate/core';
import {
  DatetimePickerComponent,
  SelectModule,
  TextareaFieldComponent,
  TextFieldComponent
} from '@q9elements/ui-kit/components';
import {DpDatePickerModule} from 'ng2-date-picker';
import {CustomNodeAttributeComponent} from './custom-node-attribute.component';

@NgModule({
  imports: [
    CommonModule,
    MatFormFieldModule,
    TranslateModule,
    ReactiveFormsModule,
    MatIconModule,
    DpDatePickerModule,
    MatSelectModule,
    MatInputModule,
    MatTooltipModule,
    SelectModule,
    DatetimePickerComponent,
    TextFieldComponent,
    TextareaFieldComponent
  ],
  declarations: [CustomNodeAttributeComponent],
  exports: [CustomNodeAttributeComponent]
})
export class CustomNodeAttributeModule {}

export {CustomNodeAttributeComponent};
